import './FormEntryPopup.scss';
import React, { useCallback, useRef, PropsWithChildren } from 'react';

import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { ValidationGroup, ValidationGroupRef } from 'devextreme-react/validation-group';
import { useScreenSize } from '../../../utils/media-query';
import { Button } from 'devextreme-react';


export const FormEntryPopup = ({
  title,
  visible,
  width = 480,
  height = 'auto',
  onSave,
  setVisible,
  wrapperAttr = { class: '' },
  isSaveDisabled = false,
  isSaveVisible = true,
  children,
  fullScreen = false,
  saveWithoutClosing = false,
}) => {
  const { isXSmall, isSmall } = useScreenSize();
  const validationGroup = useRef(null);

  const close = () => {
    validationGroup.current?.instance().reset();
    setVisible(false);
  };

  const onCancelClick = useCallback(() => {
    close();
  }, [close, validationGroup]);

  const onSaveClick = useCallback(() => {
    if (!validationGroup.current?.instance().validate().isValid) return;
    onSave && onSave();
    if (!saveWithoutClosing) close();
  }, [validationGroup]);
  const onSaveCompleteClick = useCallback(() => {
    if (!validationGroup.current?.instance().validate().isValid) return;
    onSave && onSave('vollständig');
    if (!saveWithoutClosing) close();
  }, [validationGroup]);

  return (
    <Popup
      title={title}
      visible={visible}
      fullScreen={isXSmall  || isSmall || fullScreen}
      width={width}
      wrapperAttr={{ ...wrapperAttr, class: `${wrapperAttr?.class} form-popup` }}
      height={height}
      onVisibleChange={setVisible}
    >
      <ToolbarItem
        toolbar='bottom'
        location='center'
      >
        <div className={`form-entry-popup-buttons-container ${width <= 360 ? 'flex-buttons' : ''}`}>
          <Button
            text={isXSmall ? '' : 'Abbrechen'}
            icon={isXSmall ? 'close' : undefined}
            stylingMode='outlined'
            type='normal'
            onClick={onCancelClick}
          />
          <Button
            text={isXSmall ? '' : 'Speichern'}
            icon={isXSmall ? 'save' : undefined}
           // stylingMode='contained'
           stylingMode='outlined'
            type='normal'
            disabled={isSaveDisabled}
            visible={isSaveVisible}
            onClick={onSaveClick}
          />
            <Button
            text={isXSmall ? ' & vollst.' : 'Speichern & vollständig'}
            icon={isXSmall ? 'save' : undefined}
            stylingMode='contained'
            type='default'
            disabled={isSaveDisabled}
            visible={isSaveVisible}
            onClick={onSaveCompleteClick}
          />
        </div>
      </ToolbarItem>

      <ValidationGroup ref={validationGroup}>
        {children}
      </ValidationGroup>
    </Popup>
  );
};
